import Vue from "vue";
import { i18n } from "./vue2/langs";

Vue.component("job-board-offers", require("./vue2/components/job_board/JobBoardOffers.vue").default);

class JobBoardOffers {
  constructor() {
    this.instances = [];
  }
  initInstance(instanceId) {
    let config = {
      el: instanceId,
      i18n,
      mounted: function () {
        this.$nextTick(() => {
          document.documentElement.classList.remove("md-theme-default");
        });
      },
    };
    this.instances[instanceId] = new Vue(config).$children[0];
  }
  getInstance(instanceId) {
    return this.instances[instanceId];
  }
}
window.JobBoardOffers = new JobBoardOffers();
